import { render, staticRenderFns } from "./gbOriginalExcel.vue?vue&type=template&id=ecc1d03e&scoped=true&"
import script from "./gbOriginalExcel.vue?vue&type=script&lang=js&"
export * from "./gbOriginalExcel.vue?vue&type=script&lang=js&"
import style0 from "./gbOriginalExcel.vue?vue&type=style&index=0&id=ecc1d03e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc1d03e",
  null
  
)

export default component.exports